import { render, staticRenderFns } from "./AdminsWidget.vue?vue&type=template&id=1f398a2e&"
import script from "./AdminsWidget.vue?vue&type=script&lang=js&"
export * from "./AdminsWidget.vue?vue&type=script&lang=js&"
import style0 from "./AdminsWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports